import config from '@/config';
import fetch from '@/fetch';

const BILLING_API_URL = config.url.api.billing?.replace(/\/+$/, '');

const getBilletPdf = invoiceId => {
  if (!String(invoiceId ?? '').trim()) {
    return Promise.reject({
      message: 'Invoice ID is required'
    });
  }

  if (!BILLING_API_URL) {
    return Promise.reject({
      message: 'Billing API URL is required'
    });
  }

  return fetch(
    `${BILLING_API_URL}/invoices/${encodeURIComponent(invoiceId)}/boletos/pdf`,
    {
      headers: {
        'Billing-Version': 'v1'
      }
    },
    {
      isBlob: true,
      isFile: true
    }
  );
};

export default {
  getBilletPdf
};
